
import { callServer } from 'next/dist/client/app-call-server'

function __build_action__(action, args) {
  return callServer(action.$$id, args)
}

/* __next_internal_action_entry_do_not_use__ {"2e653eb01f3e6ff0f82f2b55206131b4cc848137":"getProductDiscounts"} */ export var getProductDiscounts = createServerReference("2e653eb01f3e6ff0f82f2b55206131b4cc848137");
import { createServerReference } from "private-next-rsc-action-client-wrapper";

